import Service from '@ember/service';

import { storageFor } from 'ember-local-storage';

import { isObject } from 'rise-ui/utils/object.js';

export default class CatalogSearchesService extends Service {
  @storageFor('catalog-searches') searches;

  /**
   * Get all searches with matching name or href
   * @param {{name?:string,href?:string}} search Search object partial
   */
  getAll(search) {
    search = isObject(search) ? search : { name: search };
    const href = search.href || window.location.href;
    return this.searches.filter(s => s.href === href || s.name === search.name);
  }
  get(search) {
    return this.getAll(search)[0];
  }
  getByUrl(href) {
    href = href || window.location.href;
    return this.searches.find(s => s.href === href);
  }
  getByName(name) {
    return this.searches.find(s => s.name === name);
  }
  clear() {
    this.searches.clear();
  }
  /**
   * Save search; replacing all searches with matching name or href
   * @param {string|{name:string,href?:string}} search Name or search object
   */
  save(search) {
    search = search && search.name ? search : { name: search };
    if (!search.name) {
      throw new Error('Expected name for saved search');
    }
    search.href = search.href || window.location.href;
    this.delete(search);
    this.searches.unshiftObject(search);
  }
  /**
   * Delete all searches with matching name or href
   * @param {{name?:string,href?:string}} search Search object partial
   */
  delete(search) {
    this.searches.removeObjects(this.getAll(search));
  }
}
